
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vendors",
      function () {
        return require("private-next-pages/vendors/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/vendors"])
      });
    }
  